import { Component, OnInit  , Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { LoanService } from "../../../../loan/shared/loan.service";
import { PrintinstallmentService } from "../../../shared/print/printinstallment.service";

@Component({
  selector: 'app-rptinstallmentpopup',
  templateUrl: './rptinstallmentpopup.component.html',
  styleUrls: ['./rptinstallmentpopup.component.css']
})
export class RptinstallmentpopupComponent implements OnInit {

  CustomerList: any[] =[];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loanService: LoanService,
    private printinstallmentService: PrintinstallmentService,
    ) { }

  ngOnInit() {
    
    this.GetCustomer();
    this.data.LoanToDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    // this.data.LoanToDate = new Date(localStorage.getItem("ApplicationDate")).toUTCString();

    this.data.customerId = 0;
  }

  GenerateReports(): void {
    
    this.data.customerId = this.data.customerId;
    this.data.ReportName = "CustomerInstallmentReport";
    this.printinstallmentService.GenerateReport(this.data);
    this.dialogRef.close();
  }

  GetCustomer() {
    this.loanService.FetchCustomerList().subscribe(data => {
      this.CustomerList = data;
    })
  }

}
